import {
  selectReportDateRange,
  useAppSelector,
  useFetchEngagementSummaryReportQuery,
} from '@/store';

import { SummaryTile } from '../SummaryTile';

const title = 'Total Episodes Started';
const description =
  'Shows the total volume of episodes started in the selected time period, not unique episodes.';
export const TotalEpisodesListened = () => {
  const dateRange = useAppSelector(selectReportDateRange);
  const { data: engagementSummary, isFetching } =
    useFetchEngagementSummaryReportQuery(
      {
        dateRange: dateRange,
      },
      {
        skip: !dateRange.fromDate || !dateRange.toDate,
      },
    );

  return (
    <SummaryTile
      title={title}
      mainStat={engagementSummary?.totalStartedEpisodes?.toLocaleString() || ''}
      description={description}
      isLoading={isFetching}
    />
  );
};
